var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.8393 11.0622C2.09384 9.80558 1.83277 8.32 2.10512 6.88447C2.37747 5.44894 3.1645 4.16221 4.31843 3.2659C5.47235 2.36958 6.91379 1.92534 8.37207 2.0166C9.83036 2.10785 11.2052 2.72832 12.2384 3.7615C13.2715 4.79468 13.892 6.16949 13.9833 7.62777C14.0745 9.08606 13.6303 10.5275 12.734 11.6814C11.8377 12.8354 10.551 13.6224 9.11544 13.8947C7.67991 14.1671 6.19433 13.906 4.93766 13.1606L4.93767 13.1605L2.86539 13.7526C2.77965 13.7771 2.68892 13.7782 2.60261 13.7559C2.51629 13.7335 2.43752 13.6885 2.37447 13.6254C2.31142 13.5624 2.26638 13.4836 2.24401 13.3973C2.22164 13.311 2.22277 13.2202 2.24726 13.1345L2.83935 11.0622L2.8393 11.0622Z",
    stroke: "#00198A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.50711 11.5C8.8493 11.5009 8.19778 11.3721 7.58987 11.1208C6.98195 10.8695 6.4296 10.5007 5.96447 10.0355C5.49933 9.5704 5.13054 9.01805 4.87924 8.41014C4.62794 7.80222 4.49907 7.1507 4.50001 6.49289C4.50149 6.02988 4.68657 5.58636 5.01464 5.25962C5.34271 4.93288 5.78698 4.74961 6.25 4.75V4.75C6.32595 4.75 6.40054 4.77008 6.46623 4.8082C6.53191 4.84632 6.58635 4.90112 6.62403 4.96706L7.35472 6.24577C7.39879 6.32288 7.42152 6.41034 7.42057 6.49915C7.41963 6.58797 7.39504 6.67492 7.34935 6.75108L6.76253 7.72911C7.06444 8.3991 7.6009 8.93557 8.27089 9.23747V9.23747L9.24892 8.65066C9.32508 8.60496 9.41203 8.58038 9.50084 8.57943C9.58966 8.57849 9.67712 8.60122 9.75423 8.64528L11.0329 9.37597C11.0989 9.41365 11.1537 9.46809 11.1918 9.53378C11.2299 9.59946 11.25 9.67406 11.25 9.75V9.75C11.2487 10.2125 11.0648 10.6558 10.7385 10.9835C10.4121 11.3112 9.96959 11.4968 9.50711 11.5V11.5Z",
    stroke: "#00198A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.c83dd0c9f4750dfc5dd7c66bc5a20b1f.svg";
export { ForwardRef as ReactComponent };